import React from "react";
import { Link } from "@material-ui/core";
import { ReactComponent as EyeIcon } from '../../../assets/eye-icon.svg';
import CardButton from './CardButton';

const ViewPolicyButton = ({children, url, ...props}) => {
    return <Link href={url} target="_blank"><CardButton variant="outlined" {...props} endIcon={<EyeIcon/>}>View policy</CardButton></Link>
}

export default ViewPolicyButton;